// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__ktfHY","header":"ClearentDisclaimer_header__1dO7w","inner":"ClearentDisclaimer_inner__2-ajI"};